<!-- /src/components/common/Sidebar/User.vue -->
<template>
  <div class="menu user-menu" v-if="user">
    Welcome,<br>
    <strong>
      <em>{{ displayName }}</em> </strong
    >!
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      user: 'user/getUser',
    }),
    displayName() {
      const { user } = this;
      const firstName = user.first_name !== '' ? user.first_name : false;
      const lastName = user.last_name !== '' ? user.last_name : false;
      return (firstName && lastName) ? `${firstName} ${lastName}` : (user.name !== '' ? user.name : user.username)
    }
  },
}
</script>

<style scoped>
.user-menu {
  margin-bottom: 2rem;
}
</style>
